import { FC, SVGProps } from 'react'

import { IllustPack } from './enum'
import * as Icons from './svgs'

export { IllustPack }

export interface Props extends SVGProps<SVGSVGElement> {
  name: IllustPack
}

/**
 * 2가지 색 이상울 가지는 svg 이미지를 사용할 요량으로 제작되었으나, 현재는 용처가 불분명합니다.
 *
 * 이 컴포넌트와 atoms/Icon 컴포넌트와의 관계 정리가 필요하며, 우선 cell에 없는 새 icon을 추가할 때에는 /components/atomic/atoms/CheetahIcon에 추가해주세요.
 */
const Illust: FC<Props> = ({ name, ...svgProps }): JSX.Element | null => {
  // eslint-disable-next-line import/namespace
  const SvgIcon = Icons[name]

  if (!SvgIcon) {
    return null
  }

  return (
    <>
      <SvgIcon {...svgProps} />
    </>
  )
}

export default Illust
